import { Box, Button, InputAdornment, TextField, Typography } from "@mui/material"
import { useState } from "react"
import { COLOR } from "../../../utils/colors"
import { VIEW } from "../../../utils/breakpoint"
import { AddOutlined } from "@mui/icons-material"
import { GridSearchIcon } from "@mui/x-data-grid"
import ListLocationTable from "../location/list-location-table"

export default function ListWaypointPage({
  onCreate,
  onNext
}: {
  onCreate?: () => void
  onNext?: () => void
}) {

  const [searchTerm, setSearchTerm] = useState('')
  const onCreateNew = () => {
    onCreate?.()
  }
  return (
    <Box>
      <Box sx={(theme) => ({
        paddingY: '34px',
        color: COLOR.neutral[900],
        [theme.breakpoints.up(VIEW.PHONE)]: {
          paddingX: '24px',
        },
        [theme.breakpoints.up(VIEW.TABLET)]: {
          paddingX: '44px',
        }
      })}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography
              sx={{
                fontSize: '24px',
                fontWeight: 600,
                color: COLOR.neutral[900]
              }}
            >
              Waypoints
            </Typography>
            <Button onClick={() => onCreateNew?.()} variant="outlined" startIcon={<AddOutlined />}>
              Create New
            </Button>
          </Box>
          <Box sx={{ display: 'flex', mt: '20px' }}>
            <TextField
              id="search-store-name"
              variant="outlined"
              size="small"
              placeholder='Search Location'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              sx={{
                flex: 'auto',
                backgroundColor: 'white',
                height: "40px",
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <GridSearchIcon/>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Box>
        <ListLocationTable
          showNextButton={true}
          search={searchTerm}
          onNext={() => onNext?.()}
        />
      </Box>
    </Box>
  )
}